<template>
  <div class="fixedWrap">

    <div class="wrapItem" @click="showForm">
      <span class="iconSpan"></span>
      <span>申请体验</span>
    </div>
    <div class="wrapItem" @click="showForm">
      <span class="iconSpan"></span>
      <span>咨询客服</span>
      <div class="codeWrap">
        <h4>咨询客服</h4>
        <label>请扫描二维码</label>
        <img src="../assets/images/kf_code.png" class="codeImg" />
        <!-- <vue-qr :logoScale="20" :text="codeValue3" :margin="0" :dotScale="1" :size="size"></vue-qr> -->
      </div>
    </div>
    <div class="wrapItem" @click="showForm">
      <span class="iconSpan"></span>
      <span>咨询价格</span>
      <div class="codeWrap">
        <h4>咨询价格</h4>
        <label>请扫描二维码</label>
        <img src="../assets/images/kf_code.png" class="codeImg" />
        <!-- <vue-qr :logoScale="20" :text="codeValue3" :margin="0" :dotScale="1" :size="size"></vue-qr> -->
      </div>
    </div>
    <div class="wrapItem" @click="showForm">
      <span class="iconSpan"></span>
      <span>联系方式</span>
      <div class="codeWrap codeWrap2">
        <h4>联系方式</h4>
        <label>18536636016</label>
      </div>
    </div>
  </div>
</template>
<script>
import vueQr from 'vue-qr'
export default {
  name: 'fixedWrap',
  components:{
   vueQr
  },
  data () {
    return {
      codeValue3: '',
      size: 100,
    }
  },
  methods:{
    showForm() {
      this.$emit('changeVisible', true)
    }
  }
}
</script>
<style scoped lang="scss">
.codeWrap{
  top: -50px;
  left: -200px;
  width: 144px;
  height: 200px;
  padding: 16px 12px 2px;
  text-align: center;
  display: none;
  position: absolute;
  box-shadow: 0 6px 18px 0 #eee;
  background-color: #fff;
  z-index: 1000;
  h4 {
    color: #383838;
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 12px;
    font-family: inherit;
    line-height: 1.1;
  }
  label{
    color: #a6a6a6;
    font-size: 14px;
    margin-bottom: 12px;
    display: inline-block;
    max-width: 100%;
    font-weight: 700;
  }
}
.codeWrap2{
  height: 80px;
  top: 0px;
}
.fixedWrap{
  position: fixed;
  top: 140px;
  right: 0;
  height: 280px;
  width: 80px;
  box-shadow: 0px 2px 8px 0px #C5BAE8;
  z-index: 1000;
  .wrapItem{
    width: 80px;
    height: 53px;
    padding-top: 17px;
    background-image: linear-gradient(#FFFFFF, #F9F8FF);
    text-align: center;
    font-size: 12px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: normal;
    color: #6C7480;
    line-height: 17px;
    cursor: pointer;
    position: relative;
  }
  .wrapItem .iconSpan{
      width: 22px;
      height: 22px;
      display: block;
      margin: 0 auto 7px auto;
    }
  .wrapItem:nth-child(1) .iconSpan {
      background: url('../assets/images/sq_1.png') top left no-repeat;
    }
  .wrapItem:nth-child(2) .iconSpan {
      background: url('../assets/images/kf_1.png') top left no-repeat;
      background-size: 100%;
    }
  .wrapItem:nth-child(3) .iconSpan {
      background: url('../assets/images/xj_1.png') top left no-repeat;
    }
  .wrapItem:nth-child(4) .iconSpan {
      background: url('../assets/images/lc_1.png') top left no-repeat;
    }
  .wrapItem:nth-child(1):hover .iconSpan{
        background: url('../assets/images/sq_2.png') top left no-repeat;
      }
  .wrapItem:nth-child(2):hover .iconSpan{
        background: url('../assets/images/kf_2.png') top left no-repeat;
      }
  .wrapItem:nth-child(3):hover .iconSpan {
        background: url('../assets/images/xj_2.png') top left no-repeat;
      }
  .wrapItem:nth-child(4):hover .iconSpan {
        background: url('../assets/images/lc_2.png') top left no-repeat;
      }

  .wrapItem:hover{
      background-color: #6D3B96;
      background-image: none;
      color: #fff;
    }
  .wrapItem:hover .codeWrap{
    display: block;
    .codeImg{
      width: 120px;
      height: 120px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FixedContact.vue